import { orderApprovalPlugin } from "./plugins/order";
import { saleApprovalPlugin } from "./plugins/sale";

/** @type {Record<string, typeof orderApprovalPlugin>} */
export const approvalPlugins = {
  order: orderApprovalPlugin,
  sale: saleApprovalPlugin,
};

export function getApprovalPlugin(type) {
  return approvalPlugins[type] ?? null;
}

export function getStageConfig(item, stage = "admin") {
  const plugin = getApprovalPlugin(item?.type);
  if (!plugin) return null;
  const config = plugin.stages?.[stage];
  if (!config) return null;
  return {
    ...config,
    approveLabel: item?.approveActionLabel || config.approveLabel,
    rejectLabel: item?.rejectActionLabel || config.rejectLabel,
    rejectModalTitle: item?.rejectModalTitle || config.rejectModalTitle,
  };
}

export { getItemApprovalLabels, getApprovalResultBadge } from "./approvalSteps";
export { orderStatusConfig, getOrderStatusDisplay, hasOrderSale, canMakeSaleFromOrder } from "./plugins/order/orderDetailUtils";
